import { render, staticRenderFns } from "./act.component.html?vue&type=template&id=6e8bb4eb&scoped=true&external"
import script from "./act.component.ts?vue&type=script&lang=ts&external"
export * from "./act.component.ts?vue&type=script&lang=ts&external"
import style0 from "./act.component.scss?vue&type=style&index=0&id=6e8bb4eb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8bb4eb",
  null
  
)

export default component.exports